module.exports = __webpack_public_path__ + "843db662c38439f539aa76220c4aff7e.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/gallery/pigmentation/pigmentation-2a.jpg
 ** module id = 439
 ** module chunks = 0
 **/